import script from "./ChannelLog.vue?vue&type=script&lang=ts&setup=true&name=StockList"
export * from "./ChannelLog.vue?vue&type=script&lang=ts&setup=true&name=StockList"

const __exports__ = script;

export default __exports__